import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
const ReactQueryDevtools = React.lazy(() =>
  import.meta.env.VITE_REACT_QUERY_DEVTOOLS === 'false'
    ? Promise.resolve({ default: (() => null) as React.FC })
    : import('@tanstack/react-query-devtools').then(m => ({ default: m.ReactQueryDevtools as React.FC }))
)
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from '@/components/ui/toaster'

import App from './App.tsx'
import './index.css'
import { STALE_TIME_STRUCTURAL } from './lib/query-config'


// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE_TIME_STRUCTURAL, // 30 min default
      gcTime: 1000 * 60 * 10, // 10 minutes (formerly cacheTime)
      retry: 1,
    },
  },
})

const rootElement = document.getElementById('root')
if (!rootElement) {
  document.body.innerHTML = '<h1>Error: Root element not found</h1>'
} else {
  
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <App />
          <Toaster />
          <React.Suspense fallback={null}>
            <ReactQueryDevtools />
          </React.Suspense>
        </QueryClientProvider>
      </BrowserRouter>
    </React.StrictMode>,
  )
  
}